<template>
  <v-container fluid>
    <v-card>
      <v-overlay :value="loaderOverlay" :absolute="true">
        <v-row justify="center">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-row>
      </v-overlay>
      <v-card-title class="row no-gutters justify-start">
        <v-icon class="pr-2">mdi-account-supervisor-outline</v-icon>
        <h3 class="mb-0">{{ $t("userAdministration") }}</h3>
      </v-card-title>
      <v-card-text>
        <v-row align-content="center">
          <v-col cols="6">
            <v-text-field v-model="userListSearch" :label="$t('search')" style="border-radius: 2em / 5em" dense outlined hide-details>
              <template slot="prepend">
                <v-icon v-if="userListSearch == ''">mdi-magnify</v-icon>
                <v-icon @click="userListSearch = ''" color="primary " :style="{ cursor: 'pointer' }" v-if="userListSearch != ''">mdi-cached</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <div>
              <v-switch
                :label="!showInactiveUser ? $t('showInactiveUser') : $t('hideInactiveUser')"
                class="mt-2"
                v-model="showInactiveUser"
                hide-details
              ></v-switch>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-data-table
            v-model="selectedTasks"
            :headers="userListHeaders"
            :items="filteredUserList"
            :search="userListSearch"
            item-key="name"
            :key="refreshTable"
            @update:items-per-page="getItemPerPage"
            :items-per-page="userPerPage"
            show-select
            class="elevation-1 table-header"
            style="width: 100%"
          >
            <template v-slot:header.data-table-select="{ on, props }">
              <v-simple-checkbox v-if="false" v-bind="props" v-on="on" hide-details @input="selectAllUser(), userSelected()"> </v-simple-checkbox>
            </template>
            <template v-slot:item="{ item, select, isSelected }">
              <tr :style="setStyle(item)">
                <td></td>
                <td class="pa-0">
                  {{ item.name }}
                  <v-tooltip v-if="item.teams && item.SAPEmpID != '0000' && item.teams.length === 0" bottom color="primary">
                    <template slot="activator" slot-scope="{ on }">
                      <v-icon v-on="on" class="primary--text">mdi-exclamation-thick</v-icon>
                    </template>
                    <span v-if="item.notInSAP === true" class>{{ $t("userInSAPNotFound") }}</span>
                    <span v-else-if="item.activeInSAP === true" class>{{ $t("userHasNoTeam") }}</span>
                    <span v-else>{{ $t("employeeIsInactiveInSAP") }}</span>
                  </v-tooltip>
                </td>

                <td class="pa-0">
                  {{ item.usercode }}
                </td>
                <td class="pa-0">
                  {{ item.teamNames }}
                </td>
                <td class="pa-0">
                  <v-autocomplete
                    v-model="item.manager"
                    :items="managerUserList"
                    item-text="name"
                    style="width: 150px"
                    item-value="SAPEmpID"
                    @change="managerChanged(item)"
                  ></v-autocomplete>
                </td>
                <td class="pa-0">
                  <v-autocomplete
                    v-model="item.representative"
                    :items="managerUserList"
                    item-text="name"
                    style="width: 150px"
                    item-value="SAPEmpID"
                    @change="managerChanged(item)"
                  >
                  </v-autocomplete>
                </td>
                <td class="pa-0">
                  {{ item.timeModelName }}
                </td>
                <td class="pa-0">
                  <v-select v-model="item.state" :items="states" item-text="name" style="width: 120px" item-value="code" @change="stateChanged(item)">
                  </v-select>
                </td>
                <td>
                  <v-row justify-center>
                    <v-tooltip bottom color="primary">
                      <template slot="activator" slot-scope="{ on }" v-if="item.active == 1">
                        <v-btn icon v-on="on" @click="changePassword(item)">
                          <v-icon>mdi-lock-reset</v-icon>
                        </v-btn>
                      </template>
                      <span class="px-1">{{ $t("resetPassword") }}</span>
                    </v-tooltip>

                    <v-tooltip v-if="item.SAPEmpID != '0000' && item.active == 1" bottom color="primary">
                      <template slot="activator" slot-scope="{ on }">
                        <v-btn icon v-on="on" @click="showEditUserOverlay(item)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span v-if="item.SAPEmpID != '0000' && item.active == 1" class="pr-2">{{ $t("edit") }}</span>
                    </v-tooltip>

                    <v-tooltip v-if="item.SAPEmpID != '0000' && item.active == 1" bottom color="primary">
                      <template slot="activator" slot-scope="{ on }">
                        <v-btn
                          icon
                          v-on="on"
                          @click="
                            dialogRFID = !dialogRFID;
                            selectedUser = item;
                          "
                        >
                          <v-icon :color="setRFIDColor(item.rfid)">mdi-access-point</v-icon>
                        </v-btn>
                      </template>
                      <span class>{{ $t("RFIDRegistration") }}</span>
                    </v-tooltip>

                    <v-tooltip v-if="item.SAPEmpID != '0000' && item.active == 1 && item.rfid" bottom color="primary">
                      <template slot="activator" slot-scope="{ on }">
                        <v-btn
                          icon
                          v-on="on"
                          @click="
                            resetRFID(item.SAPEmpID);
                            selectedUser = item;
                          "
                        >
                          <v-icon color="red">mdi-access-point-remove</v-icon>
                        </v-btn>
                      </template>
                      <span class>{{ $t("RFIDReset") }}</span>
                    </v-tooltip>

                    <v-tooltip bottom color="primary" v-if="item.SAPEmpID != '0000' && item.active == 1">
                      <template slot="activator" slot-scope="{ on }">
                        <v-btn icon v-on="on" @click="deleteUsers(item)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span class>{{ $t("deactivateUser") }}</span>
                    </v-tooltip>

                    <v-tooltip bottom color="primary" v-if="item.active == 0">
                      <template slot="activator" slot-scope="{ on }">
                        <v-btn icon v-on="on" @click="activateUser(item)">
                          <v-icon>mdi-account-check</v-icon>
                        </v-btn>
                      </template>
                      <span class>{{ $t("activateUser") }}</span>
                    </v-tooltip>
                  </v-row>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-end pa-0 ma-0">
        <v-btn rounded color="primary" style="color: white" class="font-weight-medium buttonHoverOpacity pa-6 mt-2 mr-4 mb-4" @click="importUsersButton()">{{
          $t("sapImport")
        }}</v-btn>
      </v-card-actions>
    </v-card>
    <EditUser v-if="userEditDialogModel" :User="userToEdit" :selected="userToEdit.selectedGroups" @close="editUserClose()" />

    <SapUserImport
      v-if="sapDialogModel"
      :importedUsersList="userList"
      @close="
        sapDialogModel = false;
        getUsers();
      "
    />
    <ResetPassword v-if="userPasswordChangeDialog" :newpasswordonlogin="true" :empid="userToEdit.SAPEmpID" @finished="userPasswordChangeDialog = false" />
    <RFIDRegistration v-if="dialogRFID" :userId="selectedUser.SAPEmpID" :saveMode="true" @close="(dialogRFID = false), getUsers()" />
  </v-container>
</template>

<script>
export default {
  name: "UserAdministration",
  route: "UserAdministration",
  components: {
    EditUser: () => import("./EditUser.vue"),
    ResetPassword: () => import("../resetPassword.vue"),
    SapUserImport: () => import("./SapUserImport.vue"),
    RFIDRegistration: () => import("../Login/RFIDLogin.vue")
  },
  watch: {
    showInactiveUser(show) {
      this.refreshTable++;
    },
    refreshTable(item) {
      if (!this.showInactiveUser) this.filteredUserList = this.userList.filter((item) => item.active == 1);
      else this.filteredUserList = this.userList;
    }
  },
  data: () => ({
    loaderOverlay: true,
    userEditDialogModel: false,
    userPasswordChangeDialog: false,
    sapDialogModel: false,
    userListSearch: "",
    userList: [],
    filteredUserList: [],
    groupList: [],
    selectedUserList: [],
    managerUserList: [],
    timeModelFilter: "",
    userToEdit: {},

    selectedUser: "",
    refreshTable: 0,
    currentPage: 1,
    showInactiveUser: false,
    selectedTasks: [],
    userPerPage: 10,
    groups: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    dialogRFID: false,
    states: [
      { code: null, name: "" },
      { code: "BW", name: "Baden-Württemberg" },
      { code: "BY", name: "Bayern" },
      { code: "BE", name: "Berlin" },
      { code: "BB", name: "Brandenburg" },
      { code: "HB", name: "Bremen" },
      { code: "HH", name: "Hamburg" },
      { code: "HE", name: "Hessen" },
      { code: "MV", name: "Mecklenburg-Vorpommern" },
      { code: "NI", name: "Niedersachsen" },
      { code: "NW", name: "Nordrhein-Westfalen" },
      { code: "RP", name: "Rheinland-Pfalz" },
      { code: "SL", name: "Saarland" },
      { code: "SN", name: "Sachsen" },
      { code: "ST", name: "Sachsen-Anhalt" },
      { code: "SH", name: "Schleswig-Holstein" },
      { code: "TH", name: "Thüringen" }
    ]
  }),
  computed: {
    userListHeaders: function () {
      return [
        {
          text: this.$t("name"),
          value: "name",
          hint: this.$t("name"),
          align: "start",
          sortable: true,
          class: "font-weight-bold subheading pl-0"
        },
        {
          text: this.$t("sapUserCode"),
          value: "usercode",
          hint: this.$t("sapUserCode"),
          align: "start",
          sortable: true,
          class: "font-weight-bold subheading pl-0"
        },
        {
          text: this.$t("team"),
          value: "teamNames",
          hint: this.$t("team"),
          align: "start",
          sortable: true,
          class: "font-weight-bold subheading pl-0"
        },
        {
          text: this.$t("manager"),
          value: "manager",
          hint: this.$t("manager"),
          align: "start",
          sortable: true,
          class: "font-weight-bold subheading pl-0"
        },
        {
          text: this.$t("representative"),
          value: "representative",
          hint: this.$t("representative"),
          align: "start",
          sortable: true,
          class: "font-weight-bold subheading pl-0"
        },
        {
          text: this.$t("timeModel"),
          value: "timeModelName",
          hint: this.$t("timeModel"),
          align: "start",
          sortable: true,
          class: "font-weight-bold subheading pl-0"
        },
        {
          text: this.$t("state"),
          value: "state",
          hint: this.$t("state"),
          align: "start",
          sortable: true,

          class: "font-weight-bold subheading pl-0"
        },
        {
          text: "Actions",
          value: "actions",
          hint: "Actions",
          align: "start",
          width: "15%",
          sortable: false,
          class: "font-weight-bold subheading pl-0"
        }
      ];
    }
  },

  timeModelOptions() {
    let s = new Set();
    for (let u of this.userList) {
      let n = u.timeModelName || "";
      if (n) s.add(n);
    }
    return Array.from(s).sort((a, b) => a.localeCompare(b));
  },

  created: async function () {
    this.loaderOverlay = true;
    await this.getUsers();
    await this.getGroups();

    this.loaderOverlay = false;
  },

  methods: {
    getItemPerPage(val) {
      this.userPerPage = val;
    },
    async getUsers() {
      await this.$store
        .dispatch("users/getUsers")
        .then(() => {
          this.userList = this.$store.getters["users/userList"];
          for (let u of this.userList) {
            u.timeModelName = u.weekModel ? u.weekModel.Name : "";
          }
          for (let u of this.userList) {
            u.teamNames = (u.teams || []).map((t) => t.Team).join(", ");
          }
          //this.userList.unshift({ name: "", active: 1, lastName: "11111" });
          this.filteredUserList = this.userList.filter((item) => item.active == 1);
          this.managerUserList = this.filteredUserList;
          this.managerUserList.unshift({ name: "", active: 1, SAPEmpID: null });
          this.refreshTable++;
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("message", err.response.data, "error", "mdi-alert-circle-outline", "bottom", "right");
          }
        });
    },
    itemRowBackground: function (item) {},
    setStyle(item) {
      if (item.active) return;

      return this.$vuetify.theme.dark ? "background-color: #333333" : "background-color: #CFCFCF";
    },
    getGroups() {
      this.loaderOverlay = true;
      this.$store
        .dispatch("users/getGroups")
        .then(() => {
          this.groupList = this.$store.getters["users/groupList"];
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
          }
        });
    },
    changePassword(user) {
      if (user == null) {
        return;
      }
      let userToEdit = {
        editName: user.name,
        SAPEmpID: user.SAPEmpID,
        employeePin: user.pin,
        groupListselected: []
      };
      this.userToEdit = userToEdit;
      this.userPasswordChangeDialog = true;
    },
    importUsersButton() {
      this.sapDialogModel = true;
    },
    async deleteUsers(item) {
      this.loaderOverlay = true;
      let usersToDelete = [];
      if (item != undefined) usersToDelete.push(item);
      else usersToDelete = [...this.selectedUserList];

      let userNames = [];
      for (let user of usersToDelete) {
        userNames.push(user.name);
      }
      let usersString = userNames.join(",\n");
      let message = this.$t("userDeleteMessage") + " " + usersString.bold();
      await this.$dialog
        .confirm(message, {
          okText: this.$t("ok"),
          cancelText: this.$t("cancel")
        })

        .then(async () => {
          await this.$store
            .dispatch("users/deleteUsers", usersToDelete)
            .then(async () => {
              await this.getUsers();
              this.$eventHub.$emit("showSuccess", this.$t("usersSuccessfulDelete"), "bottom", "right");
            })
            .catch((err) => {
              if (err.response.status != 200) {
                this.$eventHub.$emit("showError", this.$t(err.response.data), "bottom", "right");
              }
            });
        })
        .catch(function () {
          return;
        });
      this.refreshTable++;
      this.loaderOverlay = false;
    },

    showEditUserOverlay(user) {
      if (user != null && user.SAPEmpID == "0000") {
        return;
      }

      let userToEdit = {
        Code: user.Code,
        editName: user.name,
        SAPEmpID: user.SAPEmpID,
        employeePin: user.pin,
        userStatus: user.userStatus,
        groupList: [],
        autoModelId: user.autoModelId
      };

      this.userID = user.SAPEmpID.toString();
      this.editName = user.name;
      this.employeePin = user.pin;
      userToEdit.groupList = [];
      userToEdit.selectedGroups = [];
      this.groupList.forEach((group) => {
        userToEdit.groupList.push(group);
      });
      if (user.groupIDs) {
        if (user.groupIDs.includes(",")) {
          var groups = user.groupIDs.split(",");
          var groupNames = [];
          for (var i = 0; i < this.groupList.length; i++) {
            this.groupList[i].selected = false;
            groups.forEach((group) => {
              if (group == this.groupList[i].groupId) {
                userToEdit.selectedGroups.push(this.groupList.find((group) => group.groupName == this.groupList[i].groupName));
              }
            });
          }
        } else {
          userToEdit.selectedGroups.push(this.groupList.find((group) => group.groupId == user.groupIDs));
        }
      }

      this.userToEdit = userToEdit;
      this.userEditDialogModel = true;
    },
    userSelected(item) {
      this.selectedUserList = this.filteredUserList.filter((user) => user.selected);
    },
    selectAllUser() {
      let selectedUserCounter = 0;
      this.filteredUserList.map(function (user) {
        if (user.selected) selectedUserCounter++;
      });
      if (selectedUserCounter == this.filteredUserList.length)
        this.filteredUserList.map((user) => {
          user.selected = false;
        });
      else
        this.filteredUserList.map((user) => {
          user.selected = true;
        });
    },
    setCurrentPage(item) {
      this.currentPage = item;
      this.refreshTable++;
    },
    async activateUser(user) {
      this.loaderOverlay = true;
      await this.$store
        .dispatch("users/activateUser", user.SAPEmpID)
        .then(async (res) => {
          if (res.status === 200) {
            await this.getUsers();
            await this.getGroups();
          }
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
          }
        });
      this.loaderOverlay = false;
    },
    async editUserClose() {
      this.loaderOverlay = true;
      this.userEditDialogModel = false;
      await this.getUsers();
      this.loaderOverlay = false;
    },
    setDateTableClass() {
      return "elevation-1 table-header";
    },
    setGroupStyle(group, groups) {
      let groupsArray = groups.split(",");
      let groupFound = groupsArray.find((item) => item == group);
      if (groupFound) return this.$vuetify.theme.dark ? "background-color: #990000; color: white" : "background-color: #990000; color: white";
      else return this.$vuetify.theme.dark ? "background-color: black; color: white" : "background-color: #757575; color: white";
    },
    stateChanged(selectedUser) {
      this.$store
        .dispatch("user/saveState", { userId: selectedUser.SAPEmpID, state: selectedUser.state })
        .then(async (res) => {})
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
          }
        });
    },
    managerChanged(selectedUser) {
      this.$store
        .dispatch("user/saveManager", { userId: selectedUser.SAPEmpID, manager: selectedUser.manager, representative: selectedUser.representative })
        .then(async (res) => {})
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
          }
        });
    },
    async resetRFID(item) {
      let message = this.$t("resetRFIDMessage");
      await this.$dialog
        .confirm(message, {
          okText: this.$t("ok"),
          cancelText: this.$t("cancel")
        })
        .then(async () => {
          this.$store
            .dispatch("user/saveRFID", { code: null, userId: item })
            .then(async (res) => {
              this.$eventHub.$emit("showSuccess", this.$t("rfidSuccessfullyReset"), "bottom", "right");
              this.loaderOverlay = true;
              await this.getUsers();
              this.loaderOverlay = false;
            })
            .catch((err) => {
              if (err.response.status != 200) {
                this.$eventHub.$emit("showError", this.$t(err.response.data.error), "bottom", "right");
              }
            });
        })
        .catch(function () {
          return;
        });
    },
    setRFIDColor(rfid) {
      if (rfid) {
        return "green";
      } else return "";
    }
  }
};
</script>

<style lang="scss">
td {
  padding-left: 0;
}

.theme--dark.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  background-color: #424242;
  border: 0px;
}

.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  background-color: #e0e0e0;
  border: 0px;
}

.theme--dark.v-data-table {
  background-color: #212121;
  border-radius: 12px;
}

.v-data-table__wrapper {
  border-radius: 12px;
}

.theme--light.v-data-table .v-data-footer,
.theme--dark.v-data-table .v-data-footer {
  border-top: 0px;
}

.theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row),
.theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row) {
  border-bottom: 0px;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row) {
  border-bottom: 0px;
}

.theme--light.v-data-table {
  border-radius: 12px;
}

@mixin content($darkMode: false) {
  @if $darkMode {
    thead.v-data-table-header {
      background-color: black;
    }
  }
}

.theme--dark {
  @include content(true);
}
.v-data-table__wrapper td .v-autocomplete .v-input__slot,
.v-data-table__wrapper td .v-select .v-input__slot {
  transform: translateY(2px);
}
.v-data-table__wrapper td .v-input input,
.v-data-table__wrapper td .v-select__selections,
.v-data-table__wrapper td .v-input__slot {
  font-family: Roboto, sans-serif !important;
  font-size: 14px !important;
}
</style>
